var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParagraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432 32H191.1C147.7 32 105.4 50.38 75.12 82.75C44.87 115 29.37 158.5 32.37 202.6C37.87 287.6 112.2 352 197.5 352h58.5v112c0 8.799 7.199 16 16 16s16-7.201 16-16V64h64v400c0 8.799 7.199 16 16 16s16-7.201 16-16V64H432C440.8 64 448 56.8 448 48C448 39.2 440.8 32 432 32zM255.1 320h-64c-70.75 0-128-57.25-128-128s57.25-128 128-128h64V320z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraph);
export default __webpack_public_path__ + "static/media/paragraph.eb2aabd4e94e3e6f61ea501bd9952eba.svg";
export { ForwardRef as ReactComponent };